import { TranslateService } from '@ngx-translate/core';
import { ClinicalDocument, ClinicalDocumentData } from './clinical-document.model';

export class ReferralLetter extends ClinicalDocument {
  public readonly type = 'referral-letter';

  constructor(
    data: ClinicalDocumentData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
  }
  public get label() {
    return this.translateService.instant('referral_letter_from_doctor', { doctor: this.doctor });
  }
}
